export const transformTwoFactorVerification = payload => ({
  id: payload.id,
  askUser2fa: payload.ask_user_2fa,
  showResendOption: payload.show_resend_option,
  userMaskedPhoneNumber: payload.masked_phone_number,
  userMaskedInfo: payload.user_masked_info,
  nextResendAvailableIn: payload.next_resend_available_in
});